import React from 'react';
import PropTypes from 'prop-types';
import TileGrid from 'components/TileGrid';
import List from 'components/List';

export const getTileGridButtons = ({ theme, expanded, toggleFunction, toggleMoreTextOverride }) => {
  const {
    paginationLessButton: toggleLessText,
    paginationMoreButton: toggleMoreText,
  } = window.Language;
  const seeMoreText = toggleMoreTextOverride || toggleMoreText;
  const caption = expanded ? toggleLessText : seeMoreText;
  return (
    <div className={theme.buttonsContainer}>
      <button onClick={toggleFunction} className={theme.button} type="button">
        {caption}
      </button>
    </div>
  );
};

const getTileGridButtonsAll = ({ theme, expanded, toggleFunction }) => {
  const { tileGrid_seeAllButtonText: seeAllText } = window.Language;
  return getTileGridButtons({
    theme,
    expanded,
    toggleFunction,
    toggleMoreTextOverride: seeAllText,
  });
};

export function renderGrid({
  account,
  bookmarks,
  key,
  collectionType,
  items,
  itemsCollapsed,
  listProcessor,
  gridProcessor,
  gridType,
  style,
  tileDetailToggle,
  tileTheme,
  tileType,
  tileGridTheme,
  listTheme,
  renderList,
  onLinkClick,
  onTileClick,
  onTitleClick,
  onPlayClick,
  onToggleShowMore,
  tileIndexOffset,
  tileGridTrackButtonClick,
  context,
  toggleLimit,
  renderImage,
  paginationMoreButton,
  paginationLessButton,
  shouldRenderButtons,
  isAuthenticated,
  scrollSeeLess,
  preauthorizedResources,
  expandBehavior,
}) {
  const getTileGridButtonsCall = getTileGridButtonsAll;
  const getButtons = shouldRenderButtons ? getTileGridButtonsCall : null;
  if (renderList) {
    return (
      <List
        account={account}
        key={key}
        theme={listTheme}
        items={items}
        processor={listProcessor}
        onLinkClick={onLinkClick}
        tileDetailToggle={tileDetailToggle}
        onTitleClick={onTitleClick}
        onPlayClick={onPlayClick}
        tileTheme={tileTheme}
        toggleLimit={toggleLimit}
        toggleMoreText={paginationMoreButton}
        toggleLessText={paginationLessButton}
      />
    );
  }
  return (
    <TileGrid
      account={account}
      bookmarks={bookmarks}
      collectionType={collectionType}
      context={context}
      expandBehavior={expandBehavior}
      getButtons={getButtons}
      gridType={gridType}
      isAuthenticated={isAuthenticated}
      items={items}
      itemsCollapsed={itemsCollapsed}
      key={key}
      onPlayClick={onPlayClick}
      onTileClick={onTileClick}
      onTitleClick={onTitleClick}
      onToggleShowMore={onToggleShowMore}
      preauthorizedResources={preauthorizedResources}
      processor={gridProcessor}
      renderImage={renderImage}
      scrollSeeLess={scrollSeeLess}
      style={style}
      theme={tileGridTheme}
      tileDetailToggle={tileDetailToggle}
      tileGridTrackButtonClick={tileGridTrackButtonClick}
      tileIndexOffset={tileIndexOffset}
      tileTheme={tileTheme}
      tileType={tileType}
      toggleLessText={paginationLessButton}
      toggleLimit={toggleLimit}
      toggleMoreText={paginationMoreButton}
    />
  );
}

renderGrid.defaultProps = {
  account: {},
  bookmarks: {},
  collectionType: null,
  context: null,
  expandBehavior: () => {},
  isAuthenticated: false,
  itemsCollapsed: true,
  key: null,
  listTheme: null,
  onLinkClick: null,
  onTileClick: null,
  onPlayClick: () => {},
  paginationLessButton: null,
  paginationMoreButton: null,
  preauthorizedResources: null,
  scrollSeeLess: null,
  shouldRenderButtons: null,
  tileGridTheme: null,
  tileGridTrackButtonClick: () => {},
  toggleLimit: null,
};

renderGrid.propTypes = {
  account: PropTypes.shape({}),
  bookmarks: PropTypes.shape({}),
  collectionType: PropTypes.string,
  context: PropTypes.shape({}),
  expandBehavior: PropTypes.func,
  gridProcessor: PropTypes.func.isRequired,
  gridType: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  itemsCollapsed: PropTypes.bool,
  key: PropTypes.string,
  listProcessor: PropTypes.func.isRequired,
  listTheme: PropTypes.string,
  onLinkClick: PropTypes.func,
  onTileClick: PropTypes.func,
  onTitleClick: PropTypes.func.isRequired,
  onPlayClick: () => {},
  onToggleShowMore: PropTypes.func.isRequired,
  paginationLessButton: PropTypes.shape({}),
  paginationMoreButton: PropTypes.shape({}),
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  renderImage: PropTypes.func.isRequired,
  renderList: PropTypes.bool.isRequired,
  scrollSeeLess: PropTypes.bool,
  shouldRenderButtons: PropTypes.bool,
  style: PropTypes.shape({}).isRequired,
  tileDetailToggle: PropTypes.bool.isRequired,
  tileGridTheme: PropTypes.string,
  tileGridTrackButtonClick: PropTypes.func,
  tileIndexOffset: PropTypes.number.isRequired,
  tileTheme: PropTypes.shape({}).isRequired,
  tileType: PropTypes.string.isRequired,
  toggleLimit: PropTypes.bool,
};

getTileGridButtons.defaultProps = {
  theme: {},
  expanded: false,
  toggleFunction: () => {},
  toggleMoreTextOverride: () => {},
};

getTileGridButtons.propTypes = {
  theme: PropTypes.shape({}),
  expanded: PropTypes.bool,
  toggleFunction: PropTypes.func,
  toggleMoreTextOverride: PropTypes.func,
};
